import { FC, useEffect, useState } from "react";
import { IpropsModalSettings } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import { baseUrl } from "services/config/url";
import useWindowSize from "types/other/dimensions";
import LoadingLottie from "components/lottieLoading/LoadingLottie";
const LogOutModal: FC<IpropsModalSettings> = ({ onClose, open }) => {
  const [loadingLogout, setLoadingLogout] = useState(false);
  const viewportWidth = useWindowSize();
  const logout = async () => {
    const token = localStorage.getItem("token");
    setLoadingLogout(true);
    const res = await fetch(`${baseUrl}/auth/logout`, {
      method: "POST",
      headers: { Authorization: `${token}` },
    });
    if (res) {
      setLoadingLogout(false);
      localStorage.removeItem("token");
      window.location.reload();
    } else {
      setLoadingLogout(false);
    }
  };
  const submit = () => {
    logout();
  };

  return (
    <>
      <OverlayModalCommon onClose={onClose} open={open}>
        <div
          className={
            viewportWidth >= 1200
              ? "contentModalSettingsMapPc scrollbar-div"
              : "contentModalSettingsMap"
          }
        >
          <div className="rowheaderModalSettingMap">
            <div onClick={onClose} className="icon3-close pointer" />
          </div>
          <div className="contentLogoutText">
            آیا مطمئن هستید که می خواهید از برنامه خارج شوید ؟
          </div>

          <div className="rowBtnSettingsMap">
            <div onClick={submit} className="BtnSettingsMapSubmit pointer">
              بله
            </div>
            <div onClick={onClose} className="BtnSettingsMapCancel pointer">
              انصراف
            </div>
          </div>
        </div>
      </OverlayModalCommon>
    </>
  );
};
export default LogOutModal;
